import { call, put } from 'redux-saga/effects';
import ApplyWithdrawalActions from '../redux/ApplyWithdrawalRedux';
import { api } from './api';


export function* applywithdrawalsagas(action: any): Generator<any, void, any> {
  const { withdrawal_id } = action;
  const response = yield call(api.applyWithdrawal, withdrawal_id);

  // success?
  if (response.ok) {
    // You might need to change the response here - do this with a 'transform',
    // located in ../Transforms/. Otherwise, just pass the data back from the api.
    yield put(ApplyWithdrawalActions.applyWithdrawalSuccess(response.data));
  } else {
    yield put(ApplyWithdrawalActions.applyWithdrawalFailure(response.status));
  }
}